import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

interface IGetAllThreadsSuccessWithoutDataAction {
  message: string;
}

function getAllThreadsSuccessWithoutData(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetAllThreadsSuccessWithoutDataAction>,
) {
  draft.getAllThreads.config.isLoading = false;
  draft.getAllThreads.config.emptyMessage = action.payload.message;
}

export default getAllThreadsSuccessWithoutData;
